/* Fransk katalog for locale-invoice-payment-actions-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inv.pay.undoPayment': 'Annuler le paiement',
  'inv.pay.undoRefund': 'Annuler le remboursement',
  'inv.pay.undoPaymentTitle': 'Annuler le paiement enregistré ?',
  'inv.pay.undoRefundTitle': 'Annuler le remboursement enregistré ?',
  'inv.pay.undoPaymentBody': 'Le paiement sera contrepassé et la facture rouverte avec le solde restant correspondant. L\'écriture d\'origine est conservée dans l\'historique.',
  'inv.pay.undoRefundBody': 'Le remboursement sera contrepassé et l\'avoir du client rouvert. L\'écriture d\'origine est conservée dans l\'historique.',
  'inv.toast.paymentReversed': 'Le paiement a été contrepassé',
  'inv.toast.refundReversed': 'Le remboursement a été contrepassé',
  'inv.err.paymentReverseFailed': 'Impossible de contrepasser le paiement.',
  'inv.err.refundReverseFailed': 'Impossible de contrepasser le remboursement.',
});
